/**
 * Implements an entry point for modal
 */
import { useDispatch, useSelector } from 'react-redux';
import TickersModal from './TickersModal';
import ErrorModal from './ErrorModal';
import WalletModal from './WalletModal';
import WalletPairsModal from './WalletPairsModal';
import LeverageModal from './UpgradeModal';
import LimitProxyModal from './LimitProxyModal';
import UpdateAppModal from './UpdateAppModal';
import { LimitOrderEdit, PriceAlertsEdit } from './TableEditPanels';
import ConnectModal from './Connect';
import TimeframeModal from './Timeframe';
import CexConnectModal from './CexConnectModal';
import EditProfileModal from './EditProfileModal';
import ReferralModal from './ReferralModal';
import ChangeAvatarModal from './ChangeAvatarModal';
import WelcomeModal from './WelcomeModal';
import MyTradesModal from './MyTradesModal';
import SignAuthModal from './SignAuthModal';
import { PaymentModal, StatusModal } from './Payment';
import { actionCloseModal } from '../../actions/modal';
import { IStore } from '../../reducers';
import { ModalTypes } from '../../reducers/modal';
import EditWalletTagModal from './EditWalletTagModal';

import './styles.scss';

const Backdrop = ({ onClick, className }: any) => (
  <div className={className || 'modal__backdrop'} onClick={onClick} />
);

const ModalHolder = () => {
  const modalName = useSelector((state: IStore) => state.modal.modalName);
  const props = useSelector((state: IStore) => state.modal.props);

  const dispatch = useDispatch();
  const onClose = () => dispatch(actionCloseModal());

  switch (modalName) {
  case ModalTypes.tickers:
    return (
      <>
        <TickersModal {...props} />
        <Backdrop onClick={onClose} />
      </>
    );
  case ModalTypes.offline:
    return (
      <>
        <ErrorModal header='You’re offline. Check your connection.'>
          Please refresh your browser page
        </ErrorModal>
      </>
    );
  case ModalTypes.wallet:
    return (
      <>
        <WalletModal actionCloseModal={onClose} />
        <Backdrop onClick={onClose} className='wallet_modal__backdrop' />
      </>
    );
  case ModalTypes.walletPairs:
    return <WalletPairsModal actionCloseModal={onClose} />;
  case ModalTypes.upgrade:
    return (
      <>
        <LeverageModal actionCloseModal={onClose} />
        <Backdrop onClick={onClose} />
      </>
    );
  case ModalTypes.priceAlertEdit:
    return <PriceAlertsEdit onCancel={onClose} {...props} />;
  case ModalTypes.limitOrderEdit:
    return <LimitOrderEdit onCancel={onClose} {...props} />;
  case ModalTypes.limitOrderProxy:
    return (
      <>
        <LimitProxyModal onCancel={onClose} />
        <Backdrop onClick={onClose} className='wallet_modal__backdrop' />
      </>
    );
  case ModalTypes.connect:
    return (
      <>
        <ConnectModal onCancel={onClose} />
        <Backdrop onClick={onClose} />
      </>
    );
  case ModalTypes.timeframe:
    return (
      <>
        <TimeframeModal {...props} onCancel={onClose} />
        <Backdrop onClick={onClose} />
      </>
    );
  case ModalTypes.updateApp:
    return <UpdateAppModal actionCloseModal={onClose} />;
  case ModalTypes.connectCex:
    return (
      <>
        <CexConnectModal {...props} onCancel={onClose} />
        <Backdrop onClick={onClose} />
      </>
    );
  case ModalTypes.editProfile:
    return <EditProfileModal {...props} onCancel={onClose} />;
  case ModalTypes.editWalletTag:
    return <EditWalletTagModal {...props} onCancel={onClose} />;
  case ModalTypes.referral:
    return (
      <>
        <ReferralModal onCancel={onClose} />
        <Backdrop />
      </>
    );
  case ModalTypes.changeAvatar:
    return <ChangeAvatarModal {...props} onCancel={onClose} />;
  case ModalTypes.welcome:
    return (
      <>
        <WelcomeModal onCancel={onClose} />
        <Backdrop />
      </>
    );
  case ModalTypes.myTrades:
    return (
      <>
        <MyTradesModal {...props} onCancel={onClose} />
        <Backdrop onClick={onClose} />
      </>
    );
  case ModalTypes.payment:
    return (
      <>
        <PaymentModal {...props} onCancel={onClose} />
        <Backdrop onClick={onClose} />
      </>
    );
  case ModalTypes.sign:
    return <SignAuthModal {...props} onCancel={onClose} />;
  case ModalTypes.status:
    return <StatusModal {...props} />;
  default:
    return <></>;
  }
};

export default ModalHolder;
